package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TimeInterval(
    @SerialName("from")
    val from: String?,
    @SerialName("to")
    val to: String?,
    @SerialName("__typename")
    val typename: String?
)